<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo ? formData.orderNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.purchaseStatus === 'N' ||
            formData.purchaseStatus === 'P' ||
            formData.purchaseStatus === 'C' ||
            formData.purchaseStatus === 'Y'
              ? 'success'
              : formData.purchaseStatus === 'T'
              ? 'warning'
              : formData.purchaseStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_purchaseStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyTime ? formData.modifyTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName ? formData.createByName : '--' }} at
          {{ formData.createTime ? formData.createTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName ? formData.reviewByName : '--' }} at
          {{ formData.reviewTime ? formData.reviewTime : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      size="small"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              this.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
            "
            prop="custOrderNo"
          >
            <el-input
              v-model="formData.custOrderNo"
              type="text"
              clearable
              disabled
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$l('INDEX.order_form_label_custCode') || '客户名称'"
            prop="custName"
          >
            <el-input
              v-model="formData.custName"
              type="text"
              disabled
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              this.$l('INDEX.order_form_label_endCustCode') || '终端客户名称'
            "
            prop="endCustName"
          >
            <el-input
              v-model="formData.endCustName"
              type="text"
              clearable
              size="small"
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_salesPersonCode') || '业务人员名字'
            "
            prop="salesPersonName"
          >
            <el-input
              v-model="formData.salesPersonName"
              type="text"
              clearable
              disabled
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
            prop="v_orderType"
          >
            <el-input
              v-model="formData.v_orderType"
              type="text"
              disabled
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
            prop="v_orderSource"
          >
            <el-input
              v-model="formData.v_orderSource"
              type="text"
              clearable
              disabled
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderExecuteType') || '执行方式'"
            prop="v_orderExecuteType"
          >
            <el-input
              disabled
              v-model="formData.v_orderExecuteType"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_scmCode') || '执行工厂名称'"
            prop="scmName"
          >
            <el-input
              disabled
              v-model="formData.scmName"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_reviewTime') || '订单审核时间'"
            prop="orderReviewTime"
          >
            <el-date-picker
              disabled
              v-model="formData.orderReviewTime"
              type="datetime"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
            prop="orderNo"
          >
            <el-input v-model="formData.orderNo" readonly :size="'small'">
              <el-button
                :disabled="disabled"
                slot="append"
                icon="el-icon-finished"
                @click="() => (chooseOrderDialogVisible = true)"
              ></el-button>
              ></el-input
            >
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_buyerName') || 采购人员"
            prop="buyerCode"
          >
            <dict-select
              clearable
              v-model="formData.buyerCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.buyerName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || 大货供应商"
            prop="scmCode"
          >
            <dict-select
              :placeholder="
                $l('INDEX.tips_purchase_form_label_scmCode') ||
                  '请选择大货供应商'
              "
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_contactName') || 供应商联系人"
            prop="contactName"
          >
            <el-input
              v-model="formData.contactName"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_contact_mobile') || '联系人手机'"
            prop="contactMobile"
          >
            <el-input
              v-model="formData.contactMobile"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_receiveContact') || '收货联系人'"
            prop="receiveContact"
          >
            <el-input
              v-model="formData.receiveContact"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_receiveContactMobile') || '收货联系人手机'"
            prop="receiveContactMobile"
          >
            <el-input
              v-model="formData.receiveContactMobile"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_receiverAddress') || '收货地址'"
            prop="receiveAddress"
          >
            <el-input
              v-model="formData.receiveAddress"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '采购日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_packaging_amount') || '包装金额'"
          >
            <el-input-number
              v-model="formData.packageAmount"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_surcharge') || '附加费用'">
            <el-input-number
              v-model="formData.surcharge"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_totalAmount') || '金额合计'">
            <el-input-number
              v-model="formData.totalAmount"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="this.$l('INDEX.table_label_remarks') || '备注说明'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              type="text"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" class="but_button">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <choose-order-dialog
      :visible.sync="chooseOrderDialogVisible"
      :title="'选择订单'"
      type="radio"
      @confirm="onChooseOrderConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderDialog from '@/views/factory/components/choose-order'
const initForm = { purchaseStatus: 'N', v_purchaseStatus: '新增', orderNo: '' }
export default {
  props: {
    code: String,
    disabled: Boolean,
  },
  mixins: [EditLoading],
  components: {
    ChooseOrderDialog,
  },
  data() {
    return {
      chooseOrderDialogVisible: false,
      formData: {
        ...initForm,
      },
      rules: {
        orderNo: [
          {
            required: true,
            message: this.$l('tips_select_orderNo') || '请选择订单编号',
            trigger: ' blur',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('tips_select_buyerName') || '请选择采购人员',
            trigger: ' blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_purchase_form_label_scmCode') ||
              '请选择大货供应商',
            trigger: ' blur',
          },
        ],
        receiveAddress: [
          {
            required: true,
            message: this.$l('tips_input_receiveAddress') || '请输入收货地址',
            trigger: ' blur',
          },
        ],
      },
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result)
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )
      this.loadingOpen()
      let saveApi
      if (this.code) {
        saveApi = this.$api.purchasePackageModifyApi(this.formData)
      } else {
        saveApi = this.$api.purchasePackageAddApi(this.formData)
      }
      saveApi
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('saveOkQuestion')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    getData() {
      if (!this.code) return
      this.loadingOpen()
      this.$api
        .purchasePackageDetailApi({ purchasePackageCode: this.code })
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onChooseOrderConfirm(params) {
      this.formData.orderCode = params.orderCode
      this.formData.orderNo = params.orderNo
    },
  },
  activated() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.but_button {
  margin-top: 32px;
  text-align: right;
}
</style>
